module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/标签-长图.2f8a8.png";